enum SYSTEM_ASIDES {
  ANIMALS_IN_CARE_INFO = 'ANIMALS_IN_CARE_INFO',
  APPLICATION_DETAILS = 'APPLICATION_DETAILS',
  CART_ASIDE = 'CART_ASIDE',
  CS_MIGRATION_SHELTER_INFO = 'CS_MIGRATION_SHELTER_INFO',
  FA_DETAILS_ASIDE = 'FA_DETAILS_ASIDE',
  ALL_BITE_REPORT_ASIDE = 'ALL_BITE_REPORT_ASIDE',
  FS_BITE_REPORT_ASIDE = 'FS_BITE_REPORT_ASIDE',
  FS_CASE_INFO_ASIDE = 'FS_CASE_INFO_ASIDE',
  FS_CITATIONS_ASIDE = 'FS_CITATIONS_ASIDE',
  FS_OFFICER_INFO_ASIDE = 'FS_OFFICER_INFO_ASIDE',
  MIGRATED_RECEIPT_ASIDE = 'MIGRATED_RECEIPT_ASIDE',
  RECEIPTS_ASIDE = 'RECEIPTS_ASIDE',
  SHELTER_BITE_REPORT_ASIDE = 'SHELTER_BITE_REPORT_ASIDE',
  VOUCHER_DETAILS_ASIDE = 'VOUCHER_DETAILS_ASIDE',
}

export { SYSTEM_ASIDES };
